module.exports = __webpack_public_path__ + "static/media/5DPO2.12dd0d4d.jpg";